<template>
	<v-dialog v-model="dialog" fullscreen persistent>
		<v-card>
			<v-tabs v-model="tab" background-color="transparent" grow>
				<v-tab>
					ODTs
				</v-tab>
				<v-tab>
					Instancias
				</v-tab>
				<v-tab>
					Instancia-ODT
				</v-tab>
				<v-tab>
					Calculadora tiempo
				</v-tab>
				<v-tab>
					Cierre ODT
				</v-tab>
			</v-tabs>

			<v-tabs-items v-model="tab">
				<v-tab-item>
					<ODTs ref="odtsTab" />
				</v-tab-item>
				<v-tab-item>
					<INSTANCIAs ref="instanciasTab" />
				</v-tab-item>
				<v-tab-item>
					<INSTANCIA_ODT ref="INSTANCIA_ODT" />
				</v-tab-item>
				<v-tab-item>
					<CALCULADORA_TC></CALCULADORA_TC>
				</v-tab-item>			
				<v-tab-item>
					<CIERRE_ODT />
				</v-tab-item>
			</v-tabs-items>
			<v-card-actions fixed>
				<v-spacer></v-spacer>
				<v-btn color="red" @click="closeDialog">
					<!-- <v-icon>mdi-close</v-icon> -->
					 Cerrar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import INSTANCIAs from "./Reportes/CM/INSTANCIAs.vue";
import INSTANCIA_ODT from "./Reportes/CM/INSTANCIA_ODT.vue";
import CALCULADORA_TC from "./Reportes/CM/CALCULADORA_TC.vue";
import ODTs from "./Reportes/CM/ODTs.vue";
import CIERRE_ODT from "./Reportes/CM/CIERRE_ODT.vue";

export default {
	components: {
		INSTANCIAs,
		INSTANCIA_ODT,
		CALCULADORA_TC,
		ODTs,
		CIERRE_ODT,
	},

	data() {
		return {
			dialog: false,
			tab: 0,
		};
	},

	methods: {
		openDialog() {
			this.dialog = true;
		},

		closeDialog() {
			this.dialog = false;
		},

		resetDialog() {
			this.tab = 0;

			if (this.$refs.odtsTab && typeof this.$refs.odtsTab.reset === "function") {
				this.$refs.odtsTab.reset();
			}
		},
	},

	watch: {
		dialog(value) {
			if (!value) {
				this.resetDialog();
			}
		},
	},
};
</script>
